import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../config/gtag';
import { trackPageView, initializeDataLayer } from '../config/gtm';

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GTM dataLayer
    initializeDataLayer();
    
    // Track page view with Google Analytics
    pageview(location.pathname + location.search);
    
    // Track page view with Google Tag Manager
    trackPageView(
      location.pathname + location.search,
      document.title
    );
  }, [location]);
};

export default useAnalytics;
